module.exports = __webpack_public_path__ + "media/images/category/head_img-1df3bcea2f0463badc21bb39bd3ce75b.jpg";